import { gql } from "@apollo/client";


export const updateUserSettings = gql`
  mutation updateUserSettings($nudge_interaction: Boolean, ,$nudge_delay: Int!) {
    me_UpdateSettings(nudge_interaction : $nudge_interaction, nudge_delay: $nudge_delay) {
        _id
    }
  }
`;